



















































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import gql from 'graphql-tag';

import useAuth from '@/useAuth';

import updateProfile from '@/gql/usersSetting/updateProfile.gql';
import checkInformationExists from '@/gql/usersSetting/checkInformationExists.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAvatarUpload from '@/components/User/CommonDropzoneWithAvatarUpload.vue';

const Profile = defineComponent({
  setup() {
    const { hasPermission } = useAuth();
    const form = reactive({
      id: -1,
      name: '',
      email: '',
      telephone: '',
      employeeCode: 'ไม่มีรหัสพนักงาน',
      newPassword: '',
      newPasswordConfirm: '',
      // HACK: check exist email doesn't work yet.
      failSafeEmail: '',
    });
    const avatarPath = ref('');

    const isQueryEnabled = ref(true);
    const { loading, result: meResult } = useQuery(gql`
      query getMyInfo {
        me {
          id
          name
          email
          employeeCode
          avatarPath
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
        }
      }
    `, {}, {
      fetchPolicy: 'network-only',
      enabled: isQueryEnabled.value,
    });

    watch(meResult, () => {
      const me = useResult(meResult, null, (data) => data.me);
      const item = me.value;
      if (item) isQueryEnabled.value = false; // if value is loaded, disable next query
      if (item) {
        form.id = item.id;
        form.name = item.name;
        form.email = item.email;
        // form.telephone = item.telephone;
        form.employeeCode = item.employeeCode;
        // avatarPath.value = item.avatarPath;
      }
    });

    // =================================================
    //  THIS PART USE TO VALIDATE EMAIL & TELEPHONE NO.
    // =================================================
    const mutation = useMutation(checkInformationExists);

    const failedValidatedEmailRule = ref('');
    const failedValidatedTelephoneRule = ref('');
    const failedValidatedUsernameRule = ref('');

    const checkUserInformation = _.debounce(() => {
      mutation.mutate({
        email: form.email,
        userId: form.id,
      });
    }, 300);

    watch(() => form.email, (newVal, oldVal) => {
      if (newVal !== oldVal) checkUserInformation();
    });

    mutation.onDone((response: any) => {
      if (response.data.checkExistsInformation.status === 'allow') {
        failedValidatedEmailRule.value = '';
      }
      if (response.data.checkExistsInformation.status === 'email already exists') failedValidatedEmailRule.value = `excluded:${form.email}`;
    });
    // ==================================================

    const validatedNewPassword = computed(() => {
      if (form.newPassword !== form.newPasswordConfirm) return undefined;
      return form.newPassword;
    });

    // =====================================
    // ====== UPDATE PROFILE FUNCTION ======
    // =====================================
    const successModal = ref(null);
    const failedModal = ref(null);
    const updateProfileMutation = useMutation(
      updateProfile,
      () => ({
        variables: { password: validatedNewPassword.value },
        refetchQueries: ['getMyInfo', 'me'],
      }),
    );
    updateProfileMutation.onDone((result: any) => {
      if ((result as any).data.editProfile.id) {
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลส่วนตัว' });
      } else {
        (failedModal.value as any).compose();
      }
    });

    return {
      hasPermission,
      loading,
      form,
      updateProfileMutation,
      successModal,
      failedModal,
      // avatarPath,
      // ==== Use to validate email
      failedValidatedEmailRule,
    };
  },
  components: {
    CommonModalWithPreset,
    CommonDropzoneWithAvatarUpload,
  },
});

export default Profile;
